import React from "react";
import { Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import {
  container,
  contentCol,
  divider,
  dot,
  labelCol,
  line,
  lastLine,
  row,
  trackCol,
} from "./styles_vanilla.css";
import type { TimelineItem } from "./types";

type Props = {
  items: TimelineItem[];
  showLabels?: boolean;
  showDividers?: boolean;
};

export const Timeline: React.FC<Props> = ({
  items,
  showLabels = true,
  showDividers = true,
}) => (
  <Flex flexDirection="column" className={container}>
    {items.map((item, index) => {
      const isLast = index === items.length - 1;
      return (
        <div key={item.id} className={showLabels ? row.withLabel : row.withoutLabel}>
          {showLabels ? (
            <div className={labelCol}>
              {item.label != null ? (
                <Flex flexDirection="column" alignItems="flex-end">
                  {item.label}
                </Flex>
              ) : null}
            </div>
          ) : null}
          <Flex flexDirection="column" alignItems="center" className={trackCol}>
            <Icon
              type="circle-dot"
              variant="outline"
              size="small"
              color={Colors.Neutral400}
              className={dot}
            />
            <div className={isLast ? lastLine : line} />
          </Flex>
          <Flex
            flexDirection="column"
            className={showDividers ? contentCol.withDivider : contentCol.withGap}
          >
            {item.content}
            {showDividers && !isLast ? <div className={divider} /> : null}
          </Flex>
        </div>
      );
    })}
  </Flex>
);
